import { Box, Theme, useTheme } from '@mui/material'
import MicFeature from './components/MicFeature'
import { Outlet, useLocation } from 'react-router-dom'
import { restrictedMicLocations } from './components/constants'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
const styles = (theme: Theme) => ({
  tabsContainer: {
    overflow: 'auto',
    scrollbarWidth: 'none',
    [theme.breakpoints.between('sm', 'md')]: {
      height: '68%',
    },
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
  },
})
const ProtectedMic = ({ isCampmenu }: { isCampmenu?: boolean }) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const location = useLocation()
  const segments = location?.pathname?.split('/')
  const target = segments?.[segments?.length - 1]
  const condition = restrictedMicLocations?.includes(target) || isCampmenu
  return (
    <>
      {!condition ? (
        <>
          <Box
            order={{ sm: 2, xs: 2, md: 1, lg: 1, xl: 1 }}
            className={classes?.tabsContainer}
          >
            <Outlet />
          </Box>
          <Box order={{ sm: 1, xs: 1, md: 2, lg: 2, xl: 2 }}>
            <MicFeature />
          </Box>
        </>
      ) : (
        <Box width={'100%'} p={1} className={classes?.tabsContainer}>
          <Outlet />
        </Box>
      )}
    </>
  )
}
export default ProtectedMic
